import React, { useState } from 'react';
import ReactPlayer from 'react-player';

export const VideoModal = ({ show, onClose, videoUrl }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-3 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-bold">Video</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <div className="relative aspect-video bg-black rounded-lg overflow-hidden">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
            </div>
          )}
          
          <ReactPlayer
            url={videoUrl}
            width="100%"
            height="100%"
            controls={true}
            playing={true}
            onReady={() => {
              setLoading(false);
              console.log('Video ready to play');
            }}
            onError={(e) => {
              console.error('Video error:', e);
              setError(true);
              setLoading(false);
            }}
            onBuffer={() => setLoading(true)}
            onBufferEnd={() => setLoading(false)}
            config={{
              file: {
                forceVideo: true,
                attributes: {
                  crossOrigin: "anonymous"
                }
              }
            }}
          />
          
          {error && (
            <div className="absolute bottom-0 left-0 right-0 bg-red-500 text-white p-2 text-xs">
              Error playing video. Please check console for details.
            </div>
          )}
        </div>

        <div className="mt-3 flex justify-between items-center">
          <div className="text-xs text-gray-500">
            {error ? (
              <a 
                href={videoUrl} 
                download 
                className="text-blue-500 hover:text-blue-600 underline"
              >
                Download video instead
              </a>
            ) : (
              'Use controls to start/stop playback'
            )}
          </div>
          <button
            onClick={onClose}
            className="px-3 py-1.5 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};